module.exports = __webpack_public_path__ + "resources\\localization\\de-de.json";


/*****************
 ** WEBPACK FOOTER
 ** ./src/resources/localization/de-de.json
 ** module id = 28
 ** module chunks = 0
 **/